import {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import Selector from '../../../selectors/pages/lootbox/index';
import {loadBox} from '../../../reducers/lootbox/actions';
import PageContainer from '../page-container';
import Components from '../../components';
import Header from './header';
import State from './state';

import Triggers from '../../../lib/triggers';

export default () => {
    const {box} = useSelector(Selector),
          {slug} = useParams(),
          dispatch = useDispatch(),
          location = useLocation();

    const box_loaded = box ? box.slug === slug : false;

    useEffect(() => {
        if(!box_loaded) {
            dispatch(loadBox(slug));
        } else {
            Components.Loader.closePage();
            Components.Loader.close(); 
        }
    }, [box_loaded]);

    useEffect(() => {
        Triggers.page_view({
            page: "lootbox",
            lootbox: slug
        });
    }, [location]);

    return (
        <PageContainer>
            <Components.Loader.Page />
            {box_loaded ? (
                <div className="loot-page">
                    <Components.Winners />

                    <div className="loot-container">
                        <Header />

                        {box.state === 'preview' ? <State.Preview /> : <></>} 
                        {box.state === 'animate' ? <State.Animate /> : <></>} 
                        {box.state === 'prize' ? <State.Prize /> : <></>} 

                        <div className="items-container">
                            <div className="title">Bonuses that you can get</div>

                            <div className="items-list">
                                {box.items.map((item, key) => {
                                    return (
                                        <div className={`item ${item.rarity}`} key={key}>
                                            <div className="rare"></div>
                                            <div className="image">
                                                <div className="blur"></div>
                                                <img src={`${window.location.origin}/source/system/lootbox/drops/${item.type}_${item.rarity}.png`} alt="" />
                                            </div>
                                            <div className="item_info">
                                                <div className="name">{item.name}</div>
                                                <div className="value">{item.value}</div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div> 

                    <Components.Footer />
                </div>
            ) : <></>}
        </PageContainer>
    )
}